import loadable from '@loadable/component';

export const OrgDashboardSidebarSubLayoutLoadable = loadable(
  () => import('./OrgDashboardSidebarSubLayout'),
  { resolveComponent: (module) => module.OrgDashboardSidebarSubLayout },
);
